import { render } from "./VoiceSynthesis.vue?vue&type=template&id=d1afea8a&scoped=true"
import script from "./VoiceSynthesis.vue?vue&type=script&lang=js"
export * from "./VoiceSynthesis.vue?vue&type=script&lang=js"

import "./VoiceSynthesis.vue?vue&type=style&index=0&id=d1afea8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1afea8a"]])

export default __exports__